import React from "react";
import { Label } from "@/components/form";
import Dropdown from "@/components/form/Dropdown";

interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
  description?: string; // Optional helper text shown beneath the label in the option list
  icon?: string; // Optional Google Material Icon name
  iconColor?: string; // Optional icon color class
}

interface SelectFieldProps {
  id: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  label?: string; // Optional when hideLabel is true
  placeholder?: string;
  required?: boolean;
  error?: boolean | string;
  hint?: string;
  helpText?: string; // Alias for hint (back-compat)
  className?: string;
  disabled?: boolean;
  hideLabel?: boolean;
}

const SelectField: React.FC<SelectFieldProps> = ({
  id,
  name,
  value,
  onChange,
  options,
  label = "",
  placeholder,
  required = false,
  error = false,
  hint,
  helpText,
  className = "",
  disabled = false,
  hideLabel = false,
}) => {
  const handleChange = (value: string) => {
    onChange(value);
  };

  return (
    <div className={className}>
      {/* hideLabel hides the caption on screen only; screen readers still need
          it to name the box. */}
      {(!hideLabel || label) && (
        <Label
          id={`${id}-label`}
          htmlFor={id}
          required={required}
          className={hideLabel ? 'sr-only' : ''}
        >
          {label}
        </Label>
      )}
      <Dropdown
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        required={required}
        error={typeof error === 'string' ? error : ""}
        disabled={disabled}
        ariaLabelledBy={label ? `${id}-label` : undefined}
      />
      {(hint ?? helpText) && !error && (
        <p className="mt-1.5 text-xs text-gray-500 dark:text-gray-400">{hint ?? helpText}</p>
      )}
    </div>
  );
};

export default SelectField; 